let swipers = {
    alternatives: {
        slider: false,
        elem: $('.js-alternatives-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-alternatives-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-alternatives-slider-next',
                prevEl: '.js-alternatives-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            on: {
                init: function () {
                    swipers.alternatives.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
    set: {
        slider: false,
        elem: $('.js-set-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-set-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-set-slider-next',
                prevEl: '.js-set-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            on: {
                init: function () {
                    swipers.set.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    }
};

Event.on('Window.resized', function() {
    checkSliders(swipers);
});

function wishlistModalLoaded($modal) {
    $modal.addClass('is-loaded');

    $('.js-wishlist-form').validate({
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').prop('disabled', false);

                if (!data.status) {
                    $('.js-wishlist-error')
                        .text(data.message)
                        .slideDown(200);
                } else {
                    $('.js-wishlist-success')
                        .text(data.message)
                        .slideDown(200);
                    $('.js-wishlist-hide').slideUp(200);
                }
            }, 'json');
        }
    });

    $('.js-new-wishlist-form').validate({
        submitHandler: function (form) {
            $modal.find('[type="submit"]').prop('disabled', true);
            $('.js-wishlist-error').slideUp(100);
            $('.js-wishlist-success').slideUp(100);

            Form.ajaxPost(form, function (data) {
                $modal.find('[type="submit"]').prop('disabled', false);

                if (!data.status) {
                    $('.js-wishlist-error')
                        .text(data.message)
                        .slideDown(200);
                } else {
                    $('.js-wishlist-success')
                        .text(data.message)
                        .slideDown(200);
                    $('.js-wishlist-hide').slideUp(200);
                }
            }, 'json');
        }
    });
}

$(function() {
    checkSliders(swipers);

    $('.js-product-collapse-content').each(function() {
        const $collapse = $(this);

        $collapse.shorten({
            showChars: parseInt($collapse.data('show-chars')),
            moreText: $collapse.data('more-text'),
            lessText: $collapse.data('less-text'),
            ellipsesText: '<strong> ...</strong>',
            removeTags: !$collapse.data('keep-tags')
        });
    });

    $('.js-go-back').on('click', function(e) {
        e.preventDefault();

        if (window.history.length > 1) {
            window.history.back();
        }
        else {
            window.location.href = $(this).data('category-link');
        }
    });
});